import { MEDIA_TYPES } from "./constants";

export const getPersistentPlayerPlaceholderProps = ({
    contentItem,
    playNextActive = false,
    autoPlay = false,
    routeUpdate = false,
    forcePersistence = false,
    useMediaAspectRatio = true,
    featureAttribution = null,
    disableRecommendations = true,
}) => {
    if (!contentItem?.sourceId) {
        return null;
    }

    return {
        mediaItem: {
            sourceId: contentItem.sourceId,
            title: contentItem.title ?? "",
            description: contentItem.description ?? "",
            image: {
                url: contentItem.image?.aspects?.ratio16x9?.url ?? "",
            },
            publishedAt: contentItem.publishedAt,
            type: contentItem.type,
            media: contentItem.media,
            showData: contentItem.showData ?? {},
            playNextActive,
        },
        config: {
            autoPlay,
            routeUpdate,
            forcePersistence,
            useMediaAspectRatio,
            maxHeight: 650,
        },
        ...(featureAttribution
            ? { featureAttribution: featureAttribution }
            : {}),
        disableRecommendations,
    };
};

export const getImageProps = (contentItem, aspectRatio = "ratio16x9") => {
    if (!contentItem?.sourceId) {
        return null;
    }

    return {
        alt: contentItem.altText ?? "",
        url: contentItem.aspects[aspectRatio]?.url ?? "",
        credit: contentItem.credit ?? "",
        description: contentItem.description ?? "",
    };
};

export const transformLiveStoryGQLResponseToLiveStoryProps = ({
    id = "",
    publishedAt = "",
    title = "",
    author = {
        name: "",
        url: "",
        title: "",
    },
    body = {
        parsed: [
            {
                content: [
                    {
                        content: "",
                        type: "",
                    },
                ],
                tag: "",
                type: "",
            },
        ],
        associatedContent: [],
    },
    position = 0,
} = {}) => {
    const { AUDIO, VIDEO, IMAGE } = MEDIA_TYPES;
    const associatedContent = body?.associatedContent?.[0] ?? {};
    let mediaProps = {};

    if (associatedContent.type === IMAGE) {
        const imageProps = getImageProps(associatedContent);

        if (imageProps)
            mediaProps = {
                image: imageProps,
            };
    } else if (
        associatedContent.type === VIDEO ||
        associatedContent.type === AUDIO
    ) {
        const mediaItem = getPersistentPlayerPlaceholderProps({
            contentItem: associatedContent,
        });

        if (mediaItem)
            mediaProps = {
                mediaItem: mediaItem,
            };
    }

    const liveStoryUpdateProps = {
        id,
        publishedAt,
        title,
        author,
        position,
        body: body.parsed,
        ...mediaProps,
    };

    return liveStoryUpdateProps;
};

/**
 * @returns {import("../../../stories/Components/Card/interface").TransformedCardData[]}
 */
export const transformLiveStoryMediaDataForCard = (items) => {
    return items.map((item) => {
        const transformedImage =
            item.type.toLowerCase() === "image"
                ? {
                      url: item.aspects?.ratio16x9.url,
                      aspects: item.aspects,
                  }
                : {
                      url: item.image?.aspects.ratio16x9.url,
                      aspects: item.image?.aspects,
                  };

        return {
            id: item.sourceId,
            sourceId: item.sourceId,
            title: item.title,
            description: item.description,
            image: transformedImage,
            url: item.url,
            media: {
                duration: item.media?.duration,
                hasCaptions: item.media?.hasCaptions,
            },
            type: item.type,
        };
    });
};
